import React from 'react'

export default function createShiftSlot() {
  return (
    <div>createShiftSlot</div>
  )
}
